import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=c06dd740&scoped=true"
import script from "./panel.vue?vue&type=script&lang=ts"
export * from "./panel.vue?vue&type=script&lang=ts"
import style0 from "./panel.vue?vue&type=style&index=0&id=c06dd740&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06dd740",
  null
  
)

export default component.exports